import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ceres-header-placeholder',
    templateUrl: './header-component-placeholder.component.html',
    styleUrls: ['./header-component-placeholder.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderPlaceholderComponent {}
